import httpClient from "./httpClient";
import {ADMIN_USER_NAME_MAX_LENGTH} from "@/constants/maxLengths";

const API_PREFIX = "adminauthz/v1";

export default {
  getMenuList(userAccount) {
    return httpClient.get(`${API_PREFIX}/users/${userAccount}/system-menus/GAP`);
  },
  getMenu(menuId) {
    return httpClient.get(`${API_PREFIX}/menus/${menuId}`);
  },
  getMenus() {
    return httpClient.get(`${API_PREFIX}/menus`);
  },
  getMenuById(id) {
    return httpClient.get(`${API_PREFIX}/menus/${id}`);
  },
  getGroupsBySystemType(systemType = 'GAP') {
    return httpClient.get(`${API_PREFIX}/auth-groups`, {params: {systemType}});
  },
  getAuthMenus(adAccountId) {
    return httpClient.get(`${API_PREFIX}/auth-menus`, {params: {"ad-account-id": adAccountId}})
  },

  createUser(userDto) {
    return httpClient.post(`${API_PREFIX}/users`, userDto);
  },
  getMenusByGroup(groupId) {
    return httpClient.get(`${API_PREFIX}/auth-groups/${groupId}`);
  },
  createMenu(menuDto) {
    return httpClient.post(`${API_PREFIX}/menus`, menuDto);
  },
  modifyMenu(menuDto) {
    return httpClient.put(`${API_PREFIX}/menus`, menuDto);
  },
  addMenuToGroup(groupMenuDto) {
    return httpClient.post(`${API_PREFIX}/menus/${groupMenuDto.menuId}/auth-groups`, groupMenuDto);
  },
  addUser(userDto) {
    return httpClient.post(`${API_PREFIX}/users`, userDto)
  },
  addUserToGroup(userGroupMappingDto) {
    userGroupMappingDto.userId = userGroupMappingDto.userId.replace("::LDAP","");
    userGroupMappingDto.userId = userGroupMappingDto.userId + "::LDAP";
    return httpClient.post(`${API_PREFIX}/users/${userGroupMappingDto.userId}/auth-groups`, userGroupMappingDto);
  },
  removeMenuFromGroup(groupMenuDto) {
    return httpClient.delete(`${API_PREFIX}/menus/${groupMenuDto.menuId}/auth-groups/${groupMenuDto.authGroupId}`);
  },
  createGroup(groupDto) {
    return httpClient.post(`${API_PREFIX}/auth-groups`, groupDto);
  },
  getUsersByGroupId(groupId) {
    return httpClient.get(`${API_PREFIX}/auth-groups/${groupId}/users`);
  },
  getUsersByUserIdpType(userIdpType) {
    return httpClient.get(`${API_PREFIX}/users/search?user-idp-type=${userIdpType}`);
  },
  removeUserFromGroup(userGroupMappingDto) {
    userGroupMappingDto.userId = userGroupMappingDto.userId.replace("::LDAP","");
    userGroupMappingDto.userId = userGroupMappingDto.userId + "::LDAP";
    return httpClient.delete(`${API_PREFIX}/users/${userGroupMappingDto.userId}/auth-groups/${userGroupMappingDto.authGroupId}`);
  },
  getLogs(logDto) {
    return httpClient.get(`${API_PREFIX}/logs`, {params: logDto});
  },
  getUser(fullUserId) {
    if(fullUserId==="UNKNOWN"){
      return new Promise(resolve=>{
        console.log("Promise");
        resolve ({
          data:{data:{
            user:{
              name: "-",
              id: "UNKNOWN",
              idpId: "UNKNOWN"
            }
            }}
        });
      })
    }
    return httpClient.get(`${API_PREFIX}/users/${fullUserId}`);
  },
  getUserAtLogin(fullUserId, forceRefresh) {
    return httpClient.get(`${API_PREFIX}/users/${fullUserId}/login?force-refresh=${forceRefresh}`);
  },
  postUser(createUserRequestBody) {
    if (validateUserName(createUserRequestBody)) {
      return httpClient.post(`${API_PREFIX}/users`, createUserRequestBody);
    }
  },
  putUser(modifyUserRequestBody) {
    if (validateUserName(modifyUserRequestBody)) {
      return httpClient.put(`${API_PREFIX}/users`, modifyUserRequestBody);
    }
  },
  withdrawUser(fullUserId) {
    return httpClient.put(`${API_PREFIX}/users/${fullUserId}/withdrawal`);
  },
  deleteUser(fullUserId) {
    return httpClient.delete(`${API_PREFIX}/users/${fullUserId}`);
  },
  sendAttachedEmail(email, campaignType, fileType, campaignName, notice, files) {
    let emailDto = {
      campaignType: campaignType, // 서비스 타입 : 설문, 사전예약
      fileType: fileType, // 파일 이름: 개별응답 파일, 예약자 파일
      campaignName: campaignName, // 이벤트 이름
      notice: notice, // 안내문구
      files: files, // 첨부 파일 이름 : 파일 url
    }
    return httpClient.post(`${API_PREFIX}/mail/${email}/file`, emailDto);
  },
  activateUser(fullUserId) {
    if (!fullUserId.includes("::LDAP")) {
      fullUserId = fullUserId + "::LDAP";
    }
    return httpClient.put(`${API_PREFIX}/users/${fullUserId}/activate`);
  },
  writeModifyLog(path, method, menuCode, contents, params = null) {
    return httpClient.post(`${API_PREFIX}/logs/detail`, {
                             content: contents,
                             pathMethod: `${path}::${method}`,
                             menuCode: menuCode
                           },
                           {
                             params: params
                           });
  }
}

const validateUserName = function (user) {
  let name = user.name || user;
  name = name.trim();
  if (typeof name !== "string" ||
      !name || name.length === 0) {
    alert("유저 이름을 입력해주세요.");
    return false;
  } else if (name.length > ADMIN_USER_NAME_MAX_LENGTH) {
    alert(`유저 이름은 ${ADMIN_USER_NAME_MAX_LENGTH}자 이하로 입력해주세요.`);
    return false;
  }
  return true;
};


export const getLogLevel = function(code) {
  if (code === 'CM') {
    return '로그인'
  } else if (code === 'AP') {
    return '앱 관리'
  } else if (code === 'RV') {
    return '유저 조회'
  } else if (code === 'PR') {
    return '사전예약'
  } else if (code === 'MS') {
    return '미션달성'
  } else if (code === 'CP') {
    return '쿠폰'
  } else if (code === 'SP') {
    return '배송지 입력'
  } else if (code === 'SV') {
    return '설문'
  } else {
    return code
  }
}
